import React, {Component} from 'react';
import './CustomerOrderTableRow.css';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import {Modal} from "react-bootstrap";
import Select from "react-select";

class CustomerOrderTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            status: 'Pending review',
            showTrack: false,
            statusData: [],
            statusCode: '',
            user : null

        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.truncate = this.truncate.bind(this);
    }

    onSubmit = event => {

        event.preventDefault();
        // this.saveStatus(); //TODO
        this.handleClose();
    };

    handleShow = () => {
        this.setState({
            show: true
        });
    };

    handleClose = () => {
        this.setState({show: false});
    };

    trackingOpen = () => {
        this.setState({showTrack: true});
    };

    trackingClose = () => {
        this.setState({
            showTrack: false
        });
    };

    changeStatus = (event) => {
        this.setState({
                status: event.value
            }
        )
    };

    truncate(s) {
        if (s.length > 15) {
            return s.substring(0, 12) + "...";
        } else {
            return s;
        }

    };




    render() {
        const options = [
            {value: 'Cancel', label: 'Cancel'},
            {value: 'Pending review', label: 'Pending review'},
            {value: 'Confirm', label: 'Confirm'},
            {value: 'Ordered', label: 'Ordered'},
            {value: 'In production', label: 'In production'},
            {value: 'Shipped', label: 'Shipped'}
        ];
        return (

            <tr>
                <td>
                    <span>{this.props.orders.batchNumber}</span>
                </td>
                <td>
                    <span>{this.props.orders.createdOn.substring(0,4)+"年"+this.props.orders.createdOn.substring(5,7)+"月"+this.props.orders.createdOn.substring(8,10)+"日"}</span>

                </td>
                <td>
                    <span>
                                〒{this.props.orders.orderInfo.shippingAddress.postalCode}<br/>
                        {this.props.orders.orderInfo.shippingAddress.province}<br/>
                        {this.props.orders.orderInfo.shippingAddress.city}<br/>
                        {this.props.orders.orderInfo.shippingAddress.streetAddress}<br/>
                        {this.props.orders.orderInfo.shippingAddress.addressLine2}
                            </span>
                </td>
                <td>
                     <span>
                                〒{this.props.orders.orderInfo.billingAddress.postalCode}<br/>
                         {this.props.orders.orderInfo.billingAddress.province}<br/>
                         {this.props.orders.orderInfo.billingAddress.city}<br/>
                         {this.props.orders.orderInfo.billingAddress.streetAddress}<br/>
                         {this.props.orders.orderInfo.billingAddress.addressLine2}
                            </span>
                </td>
                <td>
                    {this.props.orders.status === "IN_PRODUCTION" ? '生産中' : ''}
                    {this.props.orders.status === "PENDING" ? '保留中' : ''}
                    {this.props.orders.status === "IN_WAREHOUSE" ? '倉庫内' : ''}
                    {this.props.orders.status === "SHIPPED" ? '発送済み' : ''}
                    {this.props.orders.status === "DELIVERED" ? '配信済み' : ''}
                </td>
                <td>
                    <Link to={"/admin/orders/view/" + this.props.orders.id}
                          className="btn btn-xs btn-warning action-btn pull-right">
                        <FormattedMessage id="app.admin-all-row.view"
                                          defaultMessage="View"
                                          description=""/>
                    </Link>

                    {/*<button className="btn btn-xs btn-success  action-btn pull-right" onClick={this.trackingOpen} hidden={true}>
                            <FormattedMessage id="app.admin-all-row.track"
                                              defaultMessage="Track"
                                              description=""/>
                        </button>*/}
                    <div hidden={true}>
                        <button className="btn btn-xs btn-primary" onClick={this.handleShow}>
                            <FormattedMessage id="app.admin-all-row.status"
                                              defaultMessage="Status"
                                              description=""/>
                        </button>
                    </div>

                    <Modal show={this.state.show} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin.order.status"
                                                  defaultMessage="CHANGE STATUS:"
                                                  description=""/>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row color-text">
                                <div className="col-md-3 custom-col-3">
                                    <label>
                                        <FormattedMessage id="app.admin.order.change-status"
                                                          defaultMessage="Change status to:"
                                                          description=""/>
                                    </label>
                                </div>
                                <div className="col-md-4 custom-col-4">
                                    <Select name="status"
                                            isLoading={true}
                                            isSearchable={true}
                                            defaultValue={this.state.status}
                                            options={options}
                                            onChange={this.changeStatus}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="row color-text">
                                <div className="col-md-2  custom-col-2 pull-right">
                                    <button className="btn btn-primary bottom-button" onClick={this.onSubmit}>
                                        <FormattedMessage id="app.admin.change.status.save"
                                                          defaultMessage="Save"
                                                          description=""/>
                                    </button>
                                </div>
                                <div className="col-md-2 custom-col-2 ">
                                    <button className="btn btn-default bottom-button" onClick={this.handleClose}>
                                        <FormattedMessage id="app.admin.change.status.close"
                                                          defaultMessage="Close"
                                                          description=""/>
                                    </button>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={this.state.showTrack} onHide={this.trackingClose} className="track-order-modal">
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                {/*<FormattedMessage id="app.site.track.production.title"*/}
                                {/*defaultMessage="TRACK PRODUCTION PROCESS"*/}
                                {/*description=""/>*/}
                                生産状況
                                {/*<span>{this.props.order.id}</span>*/}
                            </div>
                        </Modal.Header>
                        <Modal.Body>

                            {/*<div className="row color-text">*/}
                            {/*<div className="col-md-4">*/}
                            {/*<label>*/}
                            {/*<FormattedMessage id="app.site.track.production.order-id"*/}
                            {/*defaultMessage="Order ID: "*/}
                            {/*description=""/></label>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-4 pull-left">*/}
                            {/*<span>{this.props.orders.id}</span>*/}
                            {/*</div>*/}
                            {/*</div>*/}
                            <div className="row color-text">
                                <div className="col-md-4 custom-col-4">
                                    <label>
                                        {/*<FormattedMessage id="app.site.track.production.batch-no"*/}
                                        {/*defaultMessage="Batch No"*/}
                                        {/*description=""/>:*/}
                                        注文番号:

                                    </label>
                                </div>admin-view-single-order-div
                                <div className="col-md-4 pull-left">
                                    <span>{this.props.orders.batchNumber}</span>
                                </div>
                            </div>
                            <div className="row color-text">
                                <div className="col-md-4 custom-col-4">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.order-status"
                                                          defaultMessage="Order Status: "
                                                          description=""/></label>
                                </div>
                                <div className="col-md-4 custom-col-4 pull-left">
                                <span>
                                    {/*{this.state.status}*/}
                                    {this.state.statusCode === "IN_PRODUCTION" ? '生産中' : ''}
                                    {this.state.statusCode === "PENDING" ? '保留中' : ''}
                                    {this.state.statusCode === "IN_WAREHOUSE" ? '倉庫内' : ''}
                                    {this.state.statusCode === "SHIPPED" ? '発送済み' : ''}
                                    {this.state.statusCode === "DELIVERED" ? '配信済み' : ''}
                                </span>
                                </div>
                            </div>

                            <div className="row color-text">
                                <div className="col-md-4 custom-col-4">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.message"
                                                          defaultMessage="Message"
                                                          description=""/> : </label>
                                </div>
                                <div className="col-md-4  custom-col-4 pull-left">
                                    {/*<span>{this.props.message}</span>*/}
                                </div>
                            </div>
                            <div className="row color-text">

                                <div className="col-md-4 custom-col-4">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.begin-time"
                                                          defaultMessage="Begin Time"
                                                          description=""/>: </label>
                                </div>
                                <div className="col-md-4 custom-col-4 pull-left">
                                    {/*<span>{this.props.begintime}</span>*/}
                                </div>
                            </div>
                            <div className="row color-text">

                                <div className="col-md-4 custom-col-4">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.end-time"
                                                          defaultMessage="End Time"
                                                          description=""/>: </label>
                                </div>
                                <div className="col-md-4 custom-col-4 pull-left">
                                    {/*<span>{this.props.begintime}</span>*/}
                                </div>
                            </div>
                            <div className="row color-text">

                                <div className="col-md-4 custom-col-4">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.process-name"
                                                          defaultMessage="Process Name"
                                                          description=""/>: </label>
                                </div>
                                <div className="col-md-4 custom-col-4 pull-left">
                                    {/*<span>{this.props.begintime}</span>*/}
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-offset-2 pull-right color-text">
                                <button className="btn btn-info bottom-button" onClick={this.trackingClose}>
                                    <FormattedMessage id="app.site.track.production.close"
                                                      defaultMessage="Close"
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </td>
            </tr>


        )
    }

}

export default CustomerOrderTableRow;



// WEBPACK FOOTER //
// ./src/components/Admin/Customer/CustomerOrderTableRow/CustomerOrderTableRow.js